exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sport-list-loader[data-v-a2c12c08]{padding:10px;background:var(--main-bg-color)}", ""]);

// exports
